import React, { useState } from "react"
import DemandCard from "./DemandCard"
import DemandDetails from "./DemandDetails"
const DemandList = ({ demands }) => {
  const [demandId, setDemand] = useState(null)
  const [isOpen, toggleOpen] = useState(false)
  function handleClick(id) {
    setDemand(id)
    toggleOpen(true)
  }

  return (
    <>
      <div className="grid grid-cols-4 gap-4 min-h-screen w-full mt-3">
        {demands.map((demand, i) => (
          <DemandCard
            demandData={demand}
            onSelect={handleClick}
            x={i % 4 === 0 ? 1 : i % 4 === 1 ? 2 : i % 4 === 2 ? 3 : 4}
            y={Math.floor(i / 4) + 1}
          />
        ))}
      </div>
      <DemandDetails
        id={demandId}
        isOpen={isOpen}
        onClose={e => toggleOpen(false)}
      />
    </>
  )
}

export default DemandList
